(() => {
  const gallerySelector = '[data-cep-swipe-gallery]';
  const mobileViewport = window.matchMedia('(max-width: 749px)');

  const initializeGallery = (gallery) => {
    if (gallery.dataset.cepSwipeReady === 'true') return;

    const stage = gallery.querySelector('.cep-stage');
    const radios = Array.from(gallery.querySelectorAll('.cep-radio'));
    if (!stage || radios.length < 2) return;

    gallery.dataset.cepSwipeReady = 'true';

    let gestureStart = null;

    const resetGesture = () => {
      gestureStart = null;
    };

    const selectRelativeSlide = (offset) => {
      const currentIndex = Math.max(0, radios.findIndex((radio) => radio.checked));
      const nextIndex = (currentIndex + offset + radios.length) % radios.length;
      radios[nextIndex].click();
    };

    stage.addEventListener(
      'touchstart',
      (event) => {
        if (!mobileViewport.matches || event.touches.length !== 1) {
          resetGesture();
          return;
        }

        const touch = event.touches[0];
        gestureStart = {
          x: touch.clientX,
          y: touch.clientY,
        };
      },
      { passive: true }
    );

    stage.addEventListener(
      'touchend',
      (event) => {
        if (!gestureStart || !mobileViewport.matches || event.changedTouches.length !== 1) {
          resetGesture();
          return;
        }

        const touch = event.changedTouches[0];
        const distanceX = touch.clientX - gestureStart.x;
        const distanceY = touch.clientY - gestureStart.y;
        const horizontalDistance = Math.abs(distanceX);
        const verticalDistance = Math.abs(distanceY);
        const swipeThreshold = Math.max(44, Math.min(stage.clientWidth * 0.12, 72));

        resetGesture();

        if (horizontalDistance < swipeThreshold || horizontalDistance <= verticalDistance * 1.2) return;

        selectRelativeSlide(distanceX < 0 ? 1 : -1);
      },
      { passive: true }
    );

    stage.addEventListener('touchcancel', resetGesture, { passive: true });
  };

  const initializeWithin = (root) => {
    if (root instanceof Element && root.matches(gallerySelector)) initializeGallery(root);
    root.querySelectorAll?.(gallerySelector).forEach(initializeGallery);
  };

  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
